import {Injectable} from '@angular/core';
import {Headers, Http, ResponseContentType} from '@angular/http';
import {GlobalVariable} from './../../shared/global';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class UsagePaymentsService {
  // private baseApiUrl = GlobalVariable.BASE_API_URL;
  private baseApiUrlTest = GlobalVariable.BASE_API_URL;
  private headers = new Headers({'Content-Type': 'application/json'});
  // private get_usage_payments = this.baseApiUrl + 'api/rest/v1/get/account/activity/';
  private get_usage_payments = this.baseApiUrlTest + 'api/UsageHistory/get/account/activity';
  // new monthly rollup data
  private get_monthly_rollup = this.baseApiUrlTest + 'api/UsageHistory/get/account/activity/monthly';
  // private get_dpp_usage_payments = this.baseApiUrl + 'api/rest/v1/get/dpp/account/activity/';
  private get_dpp_usage_payments = this.baseApiUrlTest + 'api/UsageHistory/get/dpp/account/activity';
  // private get_statement = this.baseApiUrlTest + 'api/rest/v1/account/activity/report/';
  private get_statement = this.baseApiUrlTest + 'api/UsageHistory/generate/pdf/';
  //
  private get_header_line_items = this.baseApiUrlTest + 'api/UsageHistory/get/sup/supheader';
    //
  private get_detail_line_items = this.baseApiUrlTest + 'api/UsageHistory/get/sup/supdetail';
  private get_sup_pdf = this.baseApiUrlTest + 'api/InvoiceSummary/summaries/ban/';
  private get_sup_raw = this.baseApiUrlTest + 'api/InvoiceSummary/summaries/ban/raw/';
  private get_chargeback_template = this.baseApiUrlTest + 'api/UsageHistory/chargeback/downloadTemplate';

  constructor(private http: Http) {}

	getSUPPdf(ban: number, english: boolean, mmyy?:string) {
		return this.http
			.get(this.get_sup_pdf + ban + '/' + (english ? 'en' : 'es') + (mmyy ? '/' + mmyy : ''), { responseType: ResponseContentType.Blob })
			.toPromise()
			.then(res => res)
			.catch(this.handleError);
	}

	getSUP(ban: number, english: boolean, mmyy?:string) {
		return this.http
			.get(this.get_sup_raw + ban + '/' + (english ? 'en' : 'es') + (mmyy ? '/' + mmyy : ''), { responseType: ResponseContentType.Json })
			.toPromise()
			.then(res => res)
			.catch(this.handleError);
	}

  getUsageAndPayments(obj: Object) {
      return this.http
        .post(this.get_usage_payments, obj)
        .toPromise()
        .then(res => res.json())
        .catch(this.handleError);
  }

  getMonthlyRollup(obj: Object) {
    return this.http
      .post(this.get_monthly_rollup, obj)
      .toPromise()
      .then(res => res.json())
      .catch(this.handleError);
}

  getDPPUsageAndPayments(obj: Object) {
      return this.http
        .post(this.get_dpp_usage_payments, obj)
        .toPromise()
        .then(res => res.json())
        .catch(this.handleError);
  }

  getStatement(obj: Object) {
      return this.http
        .post(this.get_statement, obj, {responseType: ResponseContentType.Blob})
        .toPromise()
        .then(res => res)
        .catch(this.handleError);
  }

  getSupHeaderLineItems(obj: Object) {
    return this.http
      .post(this.get_header_line_items, obj)
      .toPromise()
      .then(res => res.json())
      .catch(this.handleError);
  }

  getSupDetailLineItems(obj: Object) {
    return this.http
      .post(this.get_detail_line_items, obj)
      .toPromise()
      .then(res => res.json())
      .catch(this.handleError);
  }

  getChargeBackTemplate() {
    return this.http
      .get(this.get_chargeback_template,{ responseType: ResponseContentType.Blob })
      .toPromise()
      .then(res => res)
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// ./src/app/payment/usage-payments/usage-payments.service.ts